import { css } from '@emotion/css';
import React from 'react';
import { useIntl } from '@/i18n';

const styles = {
  overviewHeadline: css`
    font-size: 18px;
    line-height: 22px;
    padding-bottom: 18px;
  `,
  descText: css`
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    margin-bottom: 16px;
  `,
  linkText: css`
    color: #2267e8;
    display: flex;
    align-items: baseline;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    padding-bottom: 16px;
  `,
  icon: css`
    color: #2267e8;
    padding-right: 5px;
  `,
  helplineAvailability: css`
    color: rgb(117, 117, 117);
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 16px;
  `,
};

const CustomerService: React.FC = () => {
  const { t } = useIntl();

  return (
    <div className={'padding-top-l'}>
      <p className={styles.overviewHeadline}>
        {t({
          id: 'benefits.deposit.modal.overview.customerService.headline',
          defaultMessage: 'Noch Fragen?',
        })}
      </p>
      <p className={styles.descText}>
        {t({
          id: 'benefits.deposit.modal.overview.customerService.description',
          defaultMessage: 'Der Allianz-Kundenservice hilft dir gerne persönlich weiter',
        })}
      </p>
      <a
        className={styles.linkText}
        href={`tel:${t({
          id: 'benefits.deposit.modal.overview.customerService.phoneNumber',
          defaultMessage: '0800 900 40 04',
        })}`}
      >
        <i className={`is24-icon-telephone ${styles.icon}`} />
        {t({
          id: 'benefits.deposit.modal.overview.customerService.phoneNumber',
          defaultMessage: '0800 900 40 04',
        })}
      </a>
      <p className={styles.helplineAvailability}>
        {t({
          id: 'benefits.deposit.modal.overview.customerService.workingHours',
          defaultMessage: 'Mo - Fr 8-21 Uhr und Sa 9-17 Uhr',
        })}
      </p>
      <a
        className={styles.linkText}
        href={`mailto:${t({
          id: 'benefits.deposit.modal.overview.customerService.email',
          defaultMessage: 'allianz-mietkaution@kautionskasse.de',
        })}`}
      >
        <i className={`is24-icon-message-email ${styles.icon}`} />
        {t({
          id: 'benefits.deposit.modal.overview.customerService.email',
          defaultMessage: 'allianz-mietkaution@kautionskasse.de',
        })}
      </a>
    </div>
  );
};

export default CustomerService;
